import React from 'react';
import { Modal, Form, Input, Button, Row, Col} from 'antd';
import { LoginRequest } from '../constant';

interface LoginModalProps {
    visible: boolean;
    onCancel: () => void;
    onLogin: (data: LoginRequest) => void
    showResetPwd: () => void
}
  
const LoginModal: React.FC<LoginModalProps> = ({ visible, onCancel, onLogin, showResetPwd}) => {
  const [form] = Form.useForm();

  const onFinish = (logindata: LoginRequest) => {
    onLogin(logindata)
  };

  return (
    <Modal
      open={visible}
      title={<div style={{ textAlign: 'center' }}>Login</div>}
      className='register-text-style'
      onCancel={onCancel}
      footer={null}
      width={300}
    >
      <div className='text-xs mt-6'>
        Please enter your username and password.
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ marginTop: 20 }}
      >

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label> Username : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Please input username' }]}
              style={{
                marginBottom: 8,
              }}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Password : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input password' }]}
              style={{
                marginBottom: 8,
              }}
            >
              <Input.Password className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <div  style={{ textAlign: 'right' }}>
            <Button type="link" style={{ paddingRight: '0'}} onClick={showResetPwd}>
                Forgot Password
            </Button>
        </div>
        <div  className='grid justify-items-center'>
            <Form.Item>
              <Button type="primary" htmlType="submit" className='mt-2' style={{ width: '100px'}}>
                  Login
              </Button>
            </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};


export default LoginModal;